<template>
    <div>
        <!-- 绑定卡券 -->
        <MaskLayout :isShow="isShow" @closeMask="closeMask" :contentStyle="wrapStyle">
            <div>
                <!-- 标题 -->
                <div class="movie-box page-text-center font-weight550 font-size32 line-height10 ">绑定卡券</div>
                <!-- 内容 -->
                <div class="movie-wrapper mb4">
                    <div class="movie-box">
                        <p class="line-height7 color6D6D6D font-size32">账号</p>
                        <div class="bottom-line">
                            <input class="input-wrap font-size32" placeholder="请输入账号" v-model="account" required />
                        </div>
                    </div>
                    <!--  -->
                    <div class="movie-box mt2">
                        <p class="line-height7 color6D6D6D font-size32">密码</p>
                        <div class="bottom-line">
                            <input class="input-wrap font-size32" type="password" placeholder="请输入密码" v-model="passWord" required />
                        </div>
                    </div>
                </div>
                <!-- 按钮 -->
                <div class="movie-wrapper mb3">
                    <div class="movie-box page-text-center colorWhite font-size32 bgdF34B26 line-height7 btn-wrap" @click="bindFn">绑定</div>
                </div>
            </div>
        </MaskLayout>
        <!-- 绑定手机号 -->
        <MaskLayout key="phone" :isShow="isOpenPhone" @closeMask="closeMaskPhone" :contentStyle="wrapStyle">
            <div>
                <!-- 标题 -->
                <div class="movie-box page-text-center font-weight550 font-size32 line-height10 ">绑定手机号</div>
                <!-- 内容 -->
                <div class="movie-wrapper mb4">
                    <!-- 手机号 -->
                    <div class="movie-box">
                        <p class="line-height7 color6D6D6D font-size32">手机号</p>
                        <div class="bottom-line">
                            <input class="input-wrap font-size32" placeholder="请输入手机号" v-model="phoneNumber" />
                        </div>
                    </div>
                    <!-- 验证码 -->
                    <div class="movie-box mt2 acea-row row-between bottom-line">
                        <input class="input-wrap font-size32" style="width:60%;height:0.8rem;" placeholder="请输入验证码" v-model="verCode" />
                        <img class="img-code" @click="getCapt" :src="imgCodeUrl" />
                    </div>
                    <!-- 短信验证码 -->
                    <div class="movie-box mt2">
                        <p class="line-height7 color6D6D6D font-size32">验证码</p>
                        <div class="acea-row row-between bottom-line">
                            <input class="input-wrap font-size32" style="width:60%;" placeholder="请输入短信验证码" v-model="smsVerCode" />
                            <button
                                class="bgdf35446 colorWhite page-text-center getcode"
                                :disabled="disabled"
                                :class=" disabled?'bgdbbbbbb':''"
                                @click="getCode"
                                >{{text}}</button>
                        </div>
                    </div>
                </div>
                <!-- 按钮 -->
                <div class="movie-wrapper mb3">
                    <div class="movie-box page-text-center colorWhite font-size32 bgdF34B26 line-height7 btn-wrap" @click="confirmSub">确定提交</div>
                </div>
            </div>
        </MaskLayout>
    </div>
</template>

<script>
import {
  registerVerify,
  register
} from "@api/user";
import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import MaskLayout from "@components/MaskLayout.vue";
export default {
    name: "BindCard",
    components: {
        MaskLayout
    },
    props: {
        isShow: {
            type: Boolean,
            default: false
        },
        isOpenPhone: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        // 绑定卡券
        isShow: {
            handler(val) {
                if(val) {
                    this.account = "";
                    this.passWord = "";
                }
            }
        },
        // 绑定手机号
        isOpenPhone: {
            handler(val) {
                if (val) {
                    this.phoneNumber = '';
                    this.verCode = '';
                    this.smsVerCode = '';
                    this.disabled = false;
                }
            }
        }
    },
    data: function () {
        return {
            wrapStyle: {
                "top": "45%",
                "left": "50%",
                "transform": "translate(-50%,-50%)",
                "width": "80%",
                "height": "auto",
                "border-radius": "0.06rem"
            },
            account: '',
            passWord: '',
            //
            phoneNumber: '',
            verCode: '',
            smsVerCode: '',
            imgCodeUrl: "http://new-gzh.xiaojiangwh.com/api/login/captcha",
            text: '获取验证码',
            disabled: false
        }
    },
    methods: {
        // 绑定卡券
        closeMask: function (val) {
            this.$emit("closeMaskFn", val);
        },
        bindFn() {
            if (!this.account || !this.passWord) return this.$dialog.error("请输入账号和密码！");

            const { account, passWord } = this;
            try {
                this.$validator({
                account: [
                    required(required.message("账号")),
                    attrs.range([5, 16], attrs.range.message("账号")),
                    alpha_num(alpha_num.message("账号"))
                ],
                passWord: [
                    required(required.message("密码")),
                    attrs.range([6, 16], attrs.range.message("密码")),
                    alpha_num(alpha_num.message("密码"))
                ]
                }).validate({ account, passWord });
            } catch (e) {
                return validatorDefaultCatch(e);
            }

            let data = {
                account: this.account,
                passWord: this.passWord
            }
            this.$emit("submitFn", data);
        },
        // 绑定手机号
        closeMaskPhone: function (val) {
            this.$emit("closeMaskPhone", val);
        },
        getCapt: function () {
            let imgPath = this.imgCodeUrl.split('?')[0]+'?id='+parseInt(Math.random()*100000);
            this.imgCodeUrl = imgPath;
        },
        async getCode() {
            var that = this;
            const { phoneNumber } = that;
            try {
                await that.$validator({
                    phoneNumber: [
                    required(required.message("手机号码")),
                    chs_phone(chs_phone.message())
                    ]
                })
                .validate({ phoneNumber });
            } catch (e) {
                return validatorDefaultCatch(e);
            }

            if (this.verCode) {
                this.getCodeNum();
            } else {
                that.$dialog.error("请输入验证码！");
            }
        },
        getCodeNum: async function () {
            let that = this;
            await registerVerify({ phone: that.phoneNumber, type: "register",  verify: that.verCode })
                .then(res => {
                    that.$dialog.success(res.msg);
                    that.sendCode();
                })
                .catch(res => {
                    that.$dialog.error(res.msg);
                });
        },
        confirmSub: async function () {
            var that = this;
            const { phoneNumber, smsVerCode } = that;
            try {
                await that
                .$validator({
                    phoneNumber: [
                    required(required.message("手机号码")),
                    chs_phone(chs_phone.message())
                    ],
                    smsVerCode: [
                    required(required.message("验证码")),
                    alpha_num(alpha_num.message("验证码"))
                    ]
                })
                .validate({ phoneNumber, smsVerCode });
            } catch (e) {
                return validatorDefaultCatch(e);
            }

            let data = {
                phoneNumber,
                smsVerCode
            };
            this.$emit("mobileLogin", data);
        }
    }
}
</script>

<style scoped>
.bottom-line {
    border-bottom: 1px solid #EAEAEA;
}
.btn-wrap {
    border-radius: 0.06rem;
}
.input-wrap {
    width: 100%;
    height: .6rem;
}
.img-code {
  width: 2rem;
  height: .8rem;
}
.getcode {
    width:1.5rem;
    height:0.5rem;
    border-radius:0.3rem;
    line-height:0.5rem;
    font-size:0.25rem;
}
</style>
